<template>
  <!-- 副項目点検 -->
  <div id="AppInspectionExecuteSub">
    <!-- 上部余白 -->
    <div style="height: 10px;" />
    <div class="box" style="width: 100%;">
      <!--機器ごとの点検内容-->
      <template>
        <div style="detailArea">
          <div
            v-if="inspectionItem.machineReplace == '有り'"
            class="subtitle is-5"
            style="color: red; text-align: left;"
          >器械交換が必要な点検です。</div>
          <div>
            <!-- 患者情報 -->
            <table class="table" style="table-layout:fixed">
              <tr style="font-size: 16px;">
                <td style="width: 30%;">患者コード</td>
                <td>{{ inspectionItem.patientCode }}</td>
              </tr>
              <tr style="font-size: 16px;">
                <td>患者名</td>
                <td>{{ inspectionItem.patientName }}</td>
              </tr>
              <tr style="font-size: 16px;">
                <td>医療機関</td>
                <td>{{ inspectionItem.hospitalName }}</td>
              </tr>
              <tr style="font-size: 16px;">
                <td>診療科</td>
                <td>{{ inspectionItem.department }}</td>
              </tr>
              <tr style="font-size: 16px;">
                <td>担当医</td>
                <td>{{inspectionItem.doctorName}}</td>
              </tr>
              <tr style="font-size: 16px;">
                <td>器械交換有無</td>
                <td>{{ inspectionItem.machineReplace }}</td>
              </tr>
              <tr style="font-size: 16px;">
                <td>品目名</td>
                <td>
                  <span
                    v-if="inspectionItem.machineReplaceSerialNumber!=''"
                  >{{ inspectionItem.machineReplaceProductCode|productFilter(productMaster) }}</span>
                  <span v-else>{{ inspectionItem.productCode|productFilter(productMaster)}}</span>
                </td>
              </tr>
              <tr style="font-size: 16px;">
                <td>シリアル</td>
                <td>
                  <span
                    v-if="inspectionItem.machineReplaceSerialNumber !== ''"
                  >{{ inspectionItem.serialNumber }} ⇒ {{ inspectionItem.machineReplaceSerialNumber }}</span>
                  <span v-else>{{ inspectionItem.serialNumber }}</span>
                </td>
              </tr>
              <tr style="font-size: 16px;">
                <td>前回点検から医師処方値の変更があったか</td>
                <td>{{ inspectionItem.modifiedDoctorDirection | directionFilter }}</td>
              </tr>
              <tr style="font-size: 16px;">
                <td>処方値変更理由</td>
                <td style="word-wrap:break-word;">{{ inspectionItem.modifiedDoctorReason}}</td>
              </tr>
              <tr style="font-size: 16px;">
                <td>前回作業指示</td>
                <td style="word-wrap:break-word;">{{ inspectionItem.lastDirection }}</td>
              </tr>
              <tr style="font-size: 16px;">
                <td>予約時指示</td>
                <td style="word-wrap:break-word;">{{ inspectionItem.appointmentMemo }}</td>
              </tr>
              <tr style="font-size: 16px;">
                <td>点検実施日</td>
                <td class="column is-one-harf">
                  <span>{{formatDate2(inspectionDate)}}</span>
                </td>
              </tr>
              <tr style="font-size: 16px;">
                <td>点検期間</td>
                <td>{{inspectionItem.CTERM}}</td>
              </tr>
              <tr style="font-size: 16px;">
                <td>次回点検月</td>
                <td>{{getNextInspection(inspectionItem,true)}}</td>
              </tr>
              <tr style="font-size: 16px;">
                <td>点検指示内容</td>
                <td>
                  <b-select expanded v-model="inspectionItem.inspectionOrder">
                    <option
                      v-for="inspection in inspectionOrderList"
                      :value="inspection.key"
                      :key="inspection.key"
                      disabled="true"
                    >{{ inspection.value }}</option>
                  </b-select>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div style="height:10px;"></div>
        <div class="columns header">
          <div class="column is-1" style="text-align:left;">No.</div>
          <div class="column is-3" style="text-align:left; margin-left:10px;">点検内容</div>
          <div class="column is-2" style="text-align:left; margin-left:10px;">処方値</div>
          <div class="column is-checkBoxCol" style="text-align:left; margin-left:10px;">レ</div>
          <div class="column" style="text-align:left; margin-left:10px;">変更値</div>
          <div class="column is-1">必須解除</div>
        </div>
        <template v-for="(content, index) in inspectionItem.value">
          <heading-comp
            v-if="inspectionItem.machineType == 8 && content.contentsType == targetContentsType && (content.displayName.indexOf('リーク上限(Prog2)') != -1)"
            v-bind:key="'alarmProg2StartTitle'+index"
            v-bind:color="'backgroundColor: #209cee;'"
            v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
            v-bind:value1="'アラーム'"
          ></heading-comp>
          <heading-comp
            v-if="inspectionItem.machineType == 8 && content.contentsType == targetContentsType && (content.displayName.indexOf('オートスタート(Prog2)') != -1)"
            v-bind:key="'alarmProg2EndTitle'+index"
            v-bind:color="'backgroundColor: #209cee;'"
            v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
          ></heading-comp>
          <heading-comp
            v-if="inspectionItem.machineType == 8 && content.contentsType == targetContentsType && (content.displayName.indexOf('リーク上限(Prog3)') != -1)"
            v-bind:key="'alarmProg3StartTitle'+index"
            v-bind:color="'backgroundColor: #209cee;'"
            v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
            v-bind:value1="'アラーム'"
          ></heading-comp>
          <heading-comp
            v-if="inspectionItem.machineType == 8 && content.contentsType == targetContentsType && (content.displayName.indexOf('オートスタート(Prog3)') != -1)"
            v-bind:key="'alarmProg3EndTitle'+index"
            v-bind:color="'backgroundColor: #209cee;'"
            v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
          ></heading-comp>
          <heading-comp
            v-if="content.contentsType == targetContentsType &&
                    content.displayName.indexOf('吸気圧/IPAP/PS (PIP)(副') != -1"
            v-bind:key="'prefix-'+index"
            v-bind:color="'backgroundColor: #0e5dd3;'"
            v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
            v-bind:value1="'モニタ表示値 / モニタ実測値'"
          ></heading-comp>
          <heading-comp
            v-if="content.contentsType == targetContentsType &&
                    content.displayName.indexOf('作業音（ブロワ)（副') != -1"
            v-bind:key="'prefix-'+index"
            v-bind:color="'backgroundColor: #0e5dd3;'"
            v-bind:text-style="'font-size:15px; font-weight: bold;'"
          ></heading-comp>
          <heading-comp
            v-if="content.contentsType == targetContentsType &&
                    (content.displayName.indexOf('吸気圧上限（副') != -1)"
            v-bind:key="'prefix-'+index"
            v-bind:color="'backgroundColor: #209cee;'"
            v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
            v-bind:value1="'アラーム'"
          ></heading-comp>
          <heading-comp
            v-if="content.contentsType == targetContentsType &&
                    content.displayName.indexOf('呼吸回路タイプ(副') != -1"
            v-bind:key="'prefix-'+index"
            v-bind:color="'backgroundColor: #209cee;'"
            v-bind:text-style="'font-size:15px; font-weight: bold;'"
          ></heading-comp>
          <heading-comp
            v-if="content.contentsType == targetContentsType && 
                    content.displayName.indexOf('パーカッサー振動数') != -1"
            v-bind:key="'A40ExternalAlarmStartTitle'+index"
            v-bind:color="'backgroundColor: #000894;'"
            v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
            v-bind:value1="'パーカッサー'"
          ></heading-comp>
          <heading-comp
            v-if="inspectionItem.machineType == 12 && content.contentsType == targetContentsType && (content.displayName.indexOf('換気モード') != -1)"
            v-bind:key="'LuisaMachineinspection'+index"
            v-bind:color="addSubSystemStyleBackColorOpacity(null, 0.8)"
            v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
            v-bind:value1="'設定'"
          ></heading-comp>

          <!-- 見出し表示共通化 -->
          <span 
            v-if="header(inspectionItem, content)"
            v-bind:key="'prefix-' + index"
          >
            <heading-comp
              v-for="(header, index) in header(inspectionItem, content)"
              v-bind:key="'prefix-' + index"
              :color="'backgroundColor: ' + header.backgroundColor"
              v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
              :value1="header.headerName"
              style="margin-bottom: 10px"
            ></heading-comp>
          </span>

          <char-comp
            v-if="content.type=== 'char' &&
                  content.contentsType == targetContentsType"
            ref="itemvaluecompo"
            v-bind:key="index"
            v-bind:displayName="content.displayName"
            v-bind:prescription="content.prescription"
            v-bind:subscript="subscript"
            v-bind:index="index"
            v-bind:unit="content.unit"
            v-bind:value="content.value"
            v-bind:contentsType="content.contentsType"
            v-bind:fieldName="getInputFieldName(subscript,index+1)"
            v-bind:varsion="inspectionItem.version"
            v-bind:isDisabled="`${checkDisable(inspectionItem.subContentsValue,content.contentsType,content.displayName,subscript) ? true:false}`"
            v-bind:isValidateRequired="`${checkRequired(inspectionItem.productCode,content.type,content.sap,content.required,content.prescription,inspectionItem.subContentsValue,content.contentsType,content.displayOrder,getInputFieldName(subscript,index+1),content.displayName) ? 'required':''}|validationCheck2:${subscript},${index},'${encodeURI(content.validationRule)}'`"
            v-bind:checks="checks"
            v-bind:machineType="inspectionItem.machineType"
            v-bind:limitCollection="limitCollection"
            v-bind:requiredcheck="content.requiredcheck"
            v-bind:note="content.note"
            v-on:child-event="setValue"
            v-on:child-event-limitCheck="limitCheck"
            v-on:child-event-requiredCheck="setRequiredCheck"
          ></char-comp>
          <sel-comp
            v-if="content.type=== 'sel' &&
                  content.contentsType == targetContentsType"
            ref="itemvaluecompo"
            v-bind:key="index"
            v-bind:displayName="content.displayName"
            v-bind:displayValue="getDisplayValue(content.displayValue,content.displayName)"
            v-bind:prescription="content.prescription"
            v-bind:subscript="subscript"
            v-bind:index="index"
            v-bind:unit="content.unit"
            v-bind:value="content.value"
            v-bind:contentsType="content.contentsType"
            v-bind:fieldName="getSelectFieldName(subscript,index+1)"
            v-bind:isDisabled="`${checkDisable(inspectionItem.subContentsValue,content.contentsType,content.displayName,subscript) ? true:false}`"
            v-bind:isValidateRequired="`${checkRequired(inspectionItem.productCode,content.type,content.sap,content.required,content.prescription,inspectionItem.subContentsValue,content.contentsType,content.displayOrder,getSelectFieldName(subscript,index+1),content.displayName,content.requiredcheck) ? 'required':''}`"
            v-bind:checks="checks"
            v-bind:requiredcheck="content.requiredcheck"
            v-on:child-event="setValue"
            v-on:child-event-requiredCheck="setRequiredCheck"
          ></sel-comp>
          <radio-comp
            v-if="content.type=== 'radio' &&
                  content.contentsType == targetContentsType"
            ref="itemvaluecompo"
            v-bind:key="index"
            v-bind:displayName="content.displayName"
            v-bind:displayValue="content.displayValue"
            v-bind:prescription="content.prescription"
            v-bind:subscript="subscript"
            v-bind:index="index"
            v-bind:value="content.value"
            v-bind:contentsType="content.contentsType"
            v-bind:fieldName="getRadioFieldName(subscript,index+1)"
            v-bind:isDisabled="`${checkDisable(inspectionItem.subContentsValue,content.contentsType,content.displayName,subscript) ? true:false}`"
            v-bind:isValidateRequired="`${checkRequired(inspectionItem.productCode,content.type,content.sap,content.required,content.prescription,inspectionItem.subContentsValue,content.contentsType,content.displayOrder,getRadioFieldName(subscript,index+1),content.displayName) ? `requiredCheck:${content.value}`:''}`"
            v-on:child-event="setValue"
          ></radio-comp>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
const HeadingCompTemplate = {
  props: ["index", "color", "value1", "value2", "value3", "textStyle"],
  template: `
  <div class="columns row" :style="color">
      <div class="column is-1" style="text-align:left; margin-left:10px;"/>
      <div class="column is-3" style="text-align:left; margin-left:10px;">
        <span :style="textStyle">{{value1}}</span>
      </div>
      <div class="column is-2" style="text-align:left; margin-left:10px;">
        <span :style="textStyle">{{value2}}</span>
      </div>
      <div class="column is-checkBoxCol" style="text-align:left; margin-left:10px;"/>
      <div class="column" style="text-align:left; margin-left:10px;">
        <span :style="textStyle">{{value3}}</span>
      </div>
  </div>
  `,
  data: function() {
    return {};
  },
  created: function() {},
  methods: {}
};

const CharCompTemplate = {
  props: [
    "displayName",
    "prescription",
    "subscript",
    "index",
    "unit",
    "value",
    "fieldName",
    "isValidateRequired",
    "isDisabled",
    "contentsType",
    "varsion",
    "checks",
    "machineType",
    "limitCollection",
    "requiredcheck",
    "note"
  ],
  template: `
  <div class="columns row" v-bind:style="addStyleBackColor()">
    <!--No.-->
    <div class="column is-1" style="text-align:left; margin-left:10px;">{{index+1}}</div>
    <!--点検内容-->
    <div class="column is-3" style="text-align:left; word-break:normal;">
      <span v-if="displayName" v-bind:style="addStyleTextColor(isValidateRequired)">
        {{displayName}}
        <br />
      </span>
      <span style="color:red;" v-if="displayName.indexOf('特記事項') != -1" >
      ※ 改行は入力禁止
      </span>
      <span v-if="note">
        {{ note }}
      </span>
      <span v-if="machineType ==8">
        <span v-if="displayName == 'Ti timed(Prog2)'" >
          ※ 自動または0.2～4.0
        </span>
        <span v-if="displayName == 'ロック時間(Prog2)'" >
          ※ OFFまたは0.6～5.0
        </span>
        <span v-if="displayName == '（目標）換気量(Prog2)'" >
          ※ 100～9999
        </span>
        <span v-if="displayName == 'softSTART Tmax(min)(Prog2)'" >
          ※ OFFまたは5～45
        </span>
        <span v-if="displayName == 'softSTOP(Prog2)'" >
          ※ OFFまたは5～45
        </span>
        <span v-if="displayName == 'リーク上限(Prog2)'" >
          ※ OFFまたは0.0～1000.0
        </span>
        <span v-if="displayName == '圧力上限(Prog2)'" >
          ※ OFFまたは0.0～50.0
        </span>
        <span v-if="displayName == '無呼吸(Prog2)'" >
          ※ OFFまたは10～60(5刻み)
        </span>
        <span v-if="displayName == '１回換気量　下限(Prog2)'" >
          ※ OFFまたは0～2000
        </span>
        <span v-if="displayName == '１回換気量　上限(Prog2)'" >
          ※ OFFまたは0～2000
        </span>
        <span v-if="displayName == 'Vti　下限(Prog2)'" >
          ※ OFFまたは0～2000
        </span>
        <span v-if="displayName == 'Vti　上限(Prog2)'" >
          ※ OFFまたは0～2000
        </span>
        <span v-if="displayName == '呼吸回数　下限(Prog2)'" >
          ※ OFFまたは0.0～100.0
        </span>
        <span v-if="displayName == '呼吸回数　上限(Prog2)'" >
          ※ OFFまたは0.0～100.0
        </span>
        <span v-if="displayName == 'MV　下限(Prog2)'" >
          ※ OFFまたは0.0～100.0
        </span>
        <span v-if="displayName == 'MV　上限(Prog2)'" >
          ※ OFFまたは0.0～100.0
        </span>
        <span v-if="displayName == 'SpO2　下限(Prog2)'" >
          ※ OFFまたは0.0～100.0
        </span>
        <span v-if="displayName == 'SpO2　上限(Prog2)'" >
          ※ OFFまたは0.0～100.0
        </span>
        <span v-if="displayName == '脈拍数　下限(Prog2)'" >
          ※ OFFまたは0～999
        </span>
        <span v-if="displayName == '脈拍数　上限(Prog2)'" >
          ※ OFFまたは0～999
        </span>
        <span v-if="displayName == 'Ti timed(Prog3)'" >
          ※ 自動または0.2～4.0
        </span>
        <span v-if="displayName == 'ロック時間(Prog3)'" >
          ※ OFFまたは0.6～5.0
        </span>
        <span v-if="displayName == '（目標）換気量(Prog3)'" >
          ※ 100～9999
        </span>
        <span v-if="displayName == 'softSTART Tmax(min)(Prog3)'" >
          ※ OFFまたは5～45
        </span>
        <span v-if="displayName == 'softSTOP(Prog3)'" >
          ※ OFFまたは5～45
        </span>
        <span v-if="displayName == 'リーク上限(Prog3)'" >
          ※ OFFまたは0.0～1000.0
        </span>
        <span v-if="displayName == '圧力上限(Prog3)'" >
          ※ OFFまたは0.0～50.0
        </span>
        <span v-if="displayName == '無呼吸(Prog3)'" >
          ※ OFFまたは10～60(5刻み)
        </span>
        <span v-if="displayName == '１回換気量　下限(Prog3)'" >
          ※ OFFまたは0～2000
        </span>
        <span v-if="displayName == '１回換気量　上限(Prog3)'" >
          ※ OFFまたは0～2000
        </span>
        <span v-if="displayName == 'Vti　下限(Prog3)'" >
          ※ OFFまたは0～2000
        </span>
        <span v-if="displayName == 'Vti　上限(Prog3)'" >
          ※ OFFまたは0～2000
        </span>
        <span v-if="displayName == '呼吸回数　下限(Prog3)'" >
          ※ OFFまたは0.0～100.0
        </span>
        <span v-if="displayName == '呼吸回数　上限(Prog3)'" >
          ※ OFFまたは0.0～100.0
        </span>
        <span v-if="displayName == 'MV　下限(Prog3)'" >
          ※ OFFまたは0.0～100.0
        </span>
        <span v-if="displayName == 'MV　上限(Prog3)'" >
          ※ OFFまたは0.0～100.0
        </span>
        <span v-if="displayName == 'SpO2　下限(Prog3)'" >
          ※ OFFまたは0.0～100.0
        </span>
        <span v-if="displayName == 'SpO2　上限(Prog3)'" >
          ※ OFFまたは0.0～100.0
        </span>
        <span v-if="displayName == '脈拍数　下限(Prog3)'" >
          ※ OFFまたは0～999
        </span>
        <span v-if="displayName == '脈拍数　上限(Prog3)'" >
          ※ OFFまたは0～999
        </span>
        <span v-if="displayName == 'IPAP(min)/CPAP(Prog2)'" >
          ※ 0.0～50.0(0.2刻み)
        </span>
        <span v-if="displayName == 'EPAP(Prog2)'" >
          ※ 0.0～50.0(0.2刻み)
        </span>
        <span v-if="displayName == 'EPAPmin（autoST）(Prog2)'" >
          ※ 0.0～50.0(0.2刻み)
        </span>
        <span v-if="displayName == 'EPAPmax（autoST）(Prog2)'" >
          ※ 0.0～50.0(0.2刻み)
        </span>
        <span v-if="displayName == '△pinsp．min(autoST)(Prog2)'" >
          ※ 0.0～50.0(0.2刻み)
        </span>
        <span v-if="displayName == '呼吸回数(Prog2)'" >
          ※ 0.0～60.0(0.5刻み)
        </span>
        <span v-if="displayName == '吸気時間(Prog2)'" >
          ※ 0.5～4.0
        </span>
        <span v-if="displayName == 'Ti min(Prog2)'" >
          ※ 0.2～4.0
        </span>
        <span v-if="displayName == 'Ti max(Prog2)'" >
          ※ 0.2～4.0
        </span>
        <span v-if="displayName == 'トリガ手動設定項目 吸気(Prog2)'" >
          ※ 1～8
        </span>
        <span v-if="displayName == 'トリガ手動設定項目 呼気(％)(Prog2)'" >
          ※ 5～95
        </span>
        <span v-if="displayName == '△P(Prog2)'" >
          ※ 0.2～40.0
        </span>
        <span v-if="displayName == 'deltaP LIAM(Prog2)'" >
          ※ 0.2～36.0
        </span>
        <span v-if="displayName == 'Ti LIAM(Prog2)'" >
          ※ 1.5～6.0
        </span>
        <span v-if="displayName == 'Te LIAM(Prog2)'" >
          ※ 0.5～9.0
        </span>
        <span v-if="displayName == '継続時間(Prog2)'" >
          ※ OFFまたは1～999
        </span>
        <span v-if="displayName == '回数(Prog2)'" >
          ※ 1～10
        </span>
        <span v-if="displayName == 'HFT流量(Prog2)'" >
          ※ 5.0～60.0
        </span>
        <span v-if="displayName == '低フロー酸素(Prog2)'" >
          ※ 0.00～60.00
        </span>
        <span v-if="displayName == 'IPAP(min)/CPAP(Prog3)'" >
          ※ 0.0～50.0(0.2刻み)
        </span>
        <span v-if="displayName == 'EPAP(Prog3)'" >
          ※ 0.0～50.0(0.2刻み)
        </span>
        <span v-if="displayName == 'EPAPmin（autoST）(Prog3)'" >
          ※ 0.0～50.0(0.2刻み)
        </span>
        <span v-if="displayName == 'EPAPmax（autoST）(Prog3)'" >
          ※ 0.0～50.0(0.2刻み)
        </span>
        <span v-if="displayName == '△pinsp．min(autoST)(Prog3)'" >
          ※ 0.0～50.0(0.2刻み)
        </span>
        <span v-if="displayName == '呼吸回数(Prog3)'" >
          ※ 0.0～60.0(0.5刻み)
        </span>
        <span v-if="displayName == '吸気時間(Prog3)'" >
          ※ 0.5～4.0
        </span>
        <span v-if="displayName == 'Ti min(Prog3)'" >
          ※ 0.2～4.0
        </span>
        <span v-if="displayName == 'Ti max(Prog3)'" >
          ※ 0.2～4.0
        </span>
        <span v-if="displayName == 'トリガ手動設定項目 吸気(Prog3)'" >
          ※ 1～8
        </span>
        <span v-if="displayName == 'トリガ手動設定項目 呼気(％)(Prog3)'" >
          ※ 5～95
        </span>
        <span v-if="displayName == '△P(Prog3)'" >
          ※ 0.2～40.0
        </span>
        <span v-if="displayName == 'deltaP LIAM(Prog3)'" >
          ※ 0.2～36.0
        </span>
        <span v-if="displayName == 'Ti LIAM(Prog3)'" >
          ※ 1.5～6.0
        </span>
        <span v-if="displayName == 'Te LIAM(Prog3)'" >
          ※ 0.5～9.0
        </span>
        <span v-if="displayName == '継続時間(Prog3)'" >
          ※ OFFまたは1～999
        </span>
        <span v-if="displayName == '回数(Prog3)'" >
          ※ 1～10
        </span>
        <span v-if="displayName == 'HFT流量(Prog3)'" >
          ※ 5.0～60.0
        </span>
        <span v-if="displayName == '低フロー酸素(Prog3)'" >
          ※ 0.00～60.00
        </span>
      </span>
      <span v-if="machineType == 11">
        <span v-if="displayName.indexOf('パーカッサー振動数') != -1" >
          ※10～780の10単位刻み
        </span>
        <span v-if="displayName.indexOf('パーカッサー動作時間(分)') != -1" >
          ※0～5の整数
        </span>
        <span v-if="displayName.indexOf('パーカッサー動作時間(秒)') != -1" >
          ※0～59の整数
        </span>
      </span>
    </div>
    <!--特記事項-->
    <div class="column" v-if="isAdditionalMemoField(displayName) && isDisabled!='true'" style="text-align:left; margin-left:10px;">
      <b-field
        label
        labelPosition="on-border"
      >
        <b-input
          :name="fieldName"
          type="textarea"
          expanded
          v-model="dataValue"
          size="is-small"
          data-vv-as="点検値"
          :readonly="isDisabled=='true'"
          v-validate="isValidateRequired"
          style="width:100%;"
          :input="inputValue(dataValue,fieldName, machineType)"
        ></b-input>
      </b-field>
    </div>
    <!--処方値-->
    <div class="column is-2" v-if="!isAdditionalMemoField(displayName)" style="text-align:left; margin-left:10px;"
      >{{ getPrescriptionValue(prescription) }}
    </div>
    <!--変更チェック-->
    <div class="column is-checkBoxCol" v-if="!isAdditionalMemoField(displayName)" style="text-align:left; margin-left:10px;">
        <b-checkbox
          true-value="true"
          false-value="false"
          :disabled="isDisabled=='true'"
          :id="idName"
          @click.native="copy()"
        ></b-checkbox>
    </div>
    <!--特記事項以外-->
    <div class="column"  v-if="!isAdditionalMemoField(displayName)&& isDisabled!='true'" style="text-align:left; margin-left:10px;">
      <b-field
        label
        labelPosition="on-border"
      > 
        <div
          v-if="isIE">
          <b-field>
            <b-input
              :name="fieldName"
              expanded
              v-model="dataValue1"
              size="is-small"
              data-vv-as="点検値"
              :input="inputValue(dataValue1, fieldName, machineType)"
              :readonly="isDisabled=='true'"
              v-validate="isValidateRequired"
            ></b-input>
            <span>：</span>
            <b-input
              :name="fieldName"
              expanded
              v-model="dataValue2"
              size="is-small"
              data-vv-as="点検値"
              :input="inputValue(dataValue2,fieldName, machineType)"
              :readonly="isDisabled=='true'"
              v-validate="isValidateRequired"
            ></b-input>
          </b-field>
        </div>
        <!-- 点検値変更理由-->
        <b-input
          v-else-if="isReasonMemoField(displayName) "
          :name="fieldName"
          type="textarea"
          expanded
          v-model="dataValue"
          size="is-small"
          data-vv-as="点検値"
          :input="inputValue(dataValue,fieldName, machineType)"
          :readonly="isDisabled=='true'"
          v-validate="isValidateRequired"
        ></b-input>
        <b-input
          v-else
          :name="fieldName"
          expanded
          v-model="dataValue"
          size="is-small"
          data-vv-as="点検値"
          :input="inputValue(dataValue,fieldName, machineType)"
          :readonly="isDisabled=='true'"
          v-validate="isValidateRequired"
        ></b-input>
        <b-select
          v-if="varsion == 1 && displayName=='酸素濃度(副)'"
          expanded
          size="is-small"
          v-model="unit"
          :input="inputUnit(unit)"
        >
          <option
            v-for="unitItem in unitList"
            :value="unitItem.key"
            :key="unitItem.key"
          >{{ unitItem.value }}</option>
        </b-select>
        <span
        v-if="unit"
        style="margin-left:10px;"
        >{{unit}}</span>
      </b-field>
      <b-field>
        <span v-if="errors.has(fieldName)" style="color:red;">{{errors.first(fieldName)}}</span>
      </b-field>
      <b-field>
        <span v-if="checkFlg" style="color:red;">下限が上限値を超えています。</span>
      </b-field>
    </div>
    <!--必須項目-->
    <div class="column is-1" v-show="!isAdditionalMemoOrReasonMemo(displayName)&& isDisabled!='true'" style="text-align:left; margin-left:10px;">
      <b-field
        label
        labelPosition="on-border"
      > 
        <b-checkbox
          true-value="true"
          false-value="false"
          :disabled="isDisabled=='true'"
          :id="idName2"
          v-model="check"
          @click.native="doNotRequired(check)"
          class="requiredCheckBox"
        ></b-checkbox>
        必須解除
      </b-field>
    </div>
  </div>
  `,
  data: function() {
    var isIE = false;
    var dataValue1, dataValue2;
    var check = false;
    var target = this.fieldName;
    var result = this.$props.checks.filter(function(item) {
      return item == target;
    });
    if (result.length > 0) {
      check = true;
    }
    var unitList = [
      { key: "％", value: "％" },
      { key: "ℓ/ｍ", value: "ℓ/ｍ" }
    ];
    if (this.displayName.indexOf("I:E") != -1) {
      isIE = true;
      var ieValue = this.value.split("：");
      dataValue1 = ieValue[0];
      dataValue2 = ieValue.length > 1 ? ieValue[1] : "";
    }
    return {
      dataValue: this.value,
      idName: this.fieldName + "_check",
      unitList,
      idName2: this.fieldName + "_check2",
      check: this.requiredcheck,
      isIE,
      dataValue1,
      dataValue2,
      checkFlg: false
    };
  },
  created: function() {
    this.$validator.extend("validationCheck2", {
      getMessage: field => `入力内容に誤りがあります。再度入力してください。`,
      validate: (value, indexArray) => {
        var ret = false;
        var subscript = indexArray[0];
        var index = indexArray[1];
        // 正規表現にカンマが含まれるとパラメタ数が変化するのでここで結合する
        var validationRule = "";
        for (var i = 2; i < indexArray.length; i++) {
          validationRule += decodeURI(indexArray[i]);
          if (i != indexArray.length - 1) {
            validationRule += ",";
          }
        }
        validationRule = validationRule.replace(/'/g, "");
        // 入力値チェック
        var regex = RegExp(validationRule);
        if (regex.test(value)) {
          ret = true;
        }
        return ret;
      }
    });
  },
  methods: {
    addStyleBackColor: function() {
      if (this.isDisabled == "true") {
        return {
          "background-color": "#E1E1E1"
        };
      }
    },
    addStyleTextColor: function(isValidateRequired) {
      // 必須項目
      if (isValidateRequired.indexOf("required") != -1) {
        return {
          color: "red"
        };
      }
    },
    inputValue(result, fieldName, machineType) {
      if (this.isDisabled == "true") {
        // エラーリセット
        this.errors.remove(this.fieldName);
      }
      if (machineType == 8) {
        //プリズマ 上限下限入力値チェック
        var targetItem = this.limitCollection.filter(
          val => val.key == this.displayName
        );
        if (targetItem && targetItem.length > 0) {
          this.$emit(
            "child-event-limitCheck",
            result,
            this.subscript,
            this.index,
            targetItem[0].value,
            machineType
          );
        }
      }
      // if (machineType == 8) {
      //   if (
      //     this.displayName == "１回換気量　下限(Prog2)" ||
      //     this.displayName == "１回換気量　上限(Prog2)" ||
      //     this.displayName == "Vti　下限(Prog2)" ||
      //     this.displayName == "Vti　上限(Prog2)" ||
      //     this.displayName == "呼吸回数　下限(Prog2)" ||
      //     this.displayName == "呼吸回数　上限(Prog2)" ||
      //     this.displayName == "MV　下限(Prog2)" ||
      //     this.displayName == "MV　上限(Prog2)" ||
      //     this.displayName == "SpO2　下限(Prog2)" ||
      //     this.displayName == "SpO2　上限(Prog2)" ||
      //     this.displayName == "脈拍数　下限(Prog2)" ||
      //     this.displayName == "脈拍数　上限(Prog2)" ||
      //     this.displayName == "１回換気量　下限(Prog3)" ||
      //     this.displayName == "１回換気量　上限(Prog3)" ||
      //     this.displayName == "Vti　下限(Prog3)" ||
      //     this.displayName == "Vti　上限(Prog3)" ||
      //     this.displayName == "呼吸回数　下限(Prog3)" ||
      //     this.displayName == "呼吸回数　上限(Prog3)" ||
      //     this.displayName == "MV　下限(Prog3)" ||
      //     this.displayName == "MV　上限(Prog3)" ||
      //     this.displayName == "SpO2　下限(Prog3)" ||
      //     this.displayName == "SpO2　上限(Prog3)" ||
      //     this.displayName == "脈拍数　下限(Prog3)" ||
      //     this.displayName == "脈拍数　上限(Prog3)"
      //   ) {
      //     var number = 0;
      //     switch (this.displayName) {
      //       case "１回換気量　下限(Prog2)":
      //       case "１回換気量　上限(Prog2)":
      //         number = 1;
      //         break;
      //       case "Vti　下限(Prog2)":
      //       case "Vti　上限(Prog2)":
      //         number = 2;
      //         break;
      //       case "呼吸回数　下限(Prog2)":
      //       case "呼吸回数　上限(Prog2)":
      //         number = 3;
      //         break;
      //       case "MV　下限(Prog2)":
      //       case "MV　上限(Prog2)":
      //         number = 4;
      //         break;
      //       case "SpO2　下限(Prog2)":
      //       case "SpO2　上限(Prog2)":
      //         number = 5;
      //         break;
      //       case "脈拍数　下限(Prog2)":
      //       case "脈拍数　上限(Prog2)":
      //         number = 6;
      //         break;
      //       case "１回換気量　下限(Prog3)":
      //       case "１回換気量　上限(Prog3)":
      //         number = 7;
      //         break;
      //       case "Vti　下限(Prog3)":
      //       case "Vti　上限(Prog3)":
      //         number = 8;
      //         break;
      //       case "呼吸回数　下限(Prog3)":
      //       case "呼吸回数　上限(Prog3)":
      //         number = 9;
      //         break;
      //       case "MV　下限(Prog3)":
      //       case "MV　上限(Prog3)":
      //         number = 10;
      //         break;
      //       case "SpO2　下限(Prog3)":
      //       case "SpO2　上限(Prog3)":
      //         number = 11;
      //         break;
      //       case "脈拍数　下限(Prog3)":
      //       case "脈拍数　上限(Prog3)":
      //         number = 12;
      //         break;
      //       default:
      //         break;
      //     }
      //     this.$emit(
      //       "child-event-limitCheck",
      //       result,
      //       this.subscript,
      //       this.index,
      //       number,
      //       machineType
      //     );
      //   }
      // }
      if (this.isIE) {
        this.dataValue = this.dataValue1 + "：" + this.dataValue2;
      } else {
        this.dataValue = result;
      }
      this.$emit(
        "child-event",
        this.dataValue,
        this.subscript,
        this.index,
        false
      );
    },
    inputUnit(val) {
      this.$parent.$parent.$parent.$parent.$parent.$parent.data[
        this.subscript
      ].value[this.index].unit = val;
    },
    doNotRequired(checker) {
      if (checker == false || checker == "false") {
        this.$parent.checks.push(this.fieldName);
        //点検画面のチェックリストに値追加
        this.$parent.$parent.$parent.$parent.$parent.$parent.checkList.push(this.fieldName);
        this.$emit("child-event-requiredCheck",true,this.index);
      }
      else {
        var items = this.$parent.checks;
        var target = this.fieldName;
        var result = items.filter(function(item) {
          return item != target;
        });
        this.$parent.checks = result;

        var items = this.$parent.$parent.$parent.$parent.$parent.$parent.checkList;
        var target = this.fieldName;
        var result = items.filter(function(item) {
          return item != target;
        });
        this.$parent.$parent.$parent.$parent.$parent.$parent.checkList = result;
        this.$emit("child-event-requiredCheck",false,this.index);
      }
    },
    isAdditionalMemoField(displayName) {
      return displayName.indexOf("特記事項") >= 0;
    },
    isReasonMemoField(displayName) {
      return displayName.indexOf("点検値変更理由") >= 0;
    },
    isAdditionalMemoOrReasonMemo(displayName) {
      return (
        this.isAdditionalMemoField(displayName) ||
        this.isReasonMemoField(displayName)
      );
    },
    getPrescriptionValue(val) {
      if (val == "-" || val == "null") {
        return "";
      } else {
        return val;
      }
    },
    copy() {
      if (
        this.prescription != "-" &&
        this.prescription != "" &&
        this.prescription != null &&
        this.prescription != "null"
      ) {
        // エラーリセット
        this.errors.remove(this.fieldName);
        this.dataValue = this.prescription;
      }
    },
    letsValidate: async function() {
      const result = await this.$validator.validateAll();
      this.$parent.$parent.$parent.totalResult =
        this.$parent.$parent.$parent.totalResult && result;
      return result;
    }
  },
  components: {}
};

const SelCompTemplate = {
  props: [
    "displayName",
    "displayValue",
    "prescription",
    "subscript",
    "index",
    "unit",
    "value",
    "fieldName",
    "isValidateRequired",
    "isDisabled",
    "contentsType",
    "checks",
    "requiredcheck"
  ],
  template: `
  <div class="columns row" v-bind:style="addStyleBackColor()">
    <!--No.-->
    <div class="column is-1" style="text-align:left; margin-left:10px;">{{index+1}}</div>
    <!--点検内容-->
    <div class="column is-3" style="text-align:left;">
      <span v-if="displayName" v-bind:style="addStyleTextColor(isValidateRequired)">
        {{displayName}}
        <br />
      </span>
      <span v-if="displayName.indexOf('圧力表示') != -1">
      ※ パーカッサー選択時はBarを選択
      </span>
    </div>
    <!--処方値-->
    <div class="column is-2" style="text-align:left; margin-left:10px;"
    >{{ getSelectValue(displayValue,prescription) }}</div>
    <!--変更チェック-->
    <div class="column is-checkBoxCol" style="text-align:left; margin-left:10px;">
      <b-checkbox
        true-value="true"
        false-value="false"
        :disabled="isDisabled=='true'"
        :id="idName"
        @click.native="copy()"
      ></b-checkbox>
    </div>
    <!--点検値-->
    <div class="column" v-if="isDisabled!='true'" style="text-align:left; margin-left:10px;">
      <b-field
        label
        labelPosition="on-border"
      >
        <b-select
          expanded
          size="is-small"
          v-model="dataValue"
          :name="fieldName"
          data-vv-as="点検値"
          :input="inputValue(dataValue,fieldName)"
          v-validate="isValidateRequired"
        >
          <option
            v-for="tmpValue in displayValue"
            :disabled="isDisabled=='true'"
            :value="tmpValue.key"
            :key="tmpValue.key"
            :name="fieldName"
          >{{ tmpValue.value }}</option>
        </b-select>
        <span style="margin-left:10px;" v-if="unit">{{unit}}</span>
      </b-field>
      <b-field>
        <span v-if="errors.has(fieldName)" style="color:red;">{{errors.first(fieldName)}}</span>
      </b-field>
    </div>
    <div class="column" v-else style="text-align:left; margin-left:10px;"></div>
    <!--必須項目-->
    <div class="column is-1" v-show="isDisabled!='true'" style="text-align:left; margin-left:10px;">
      <b-field
        label
        labelPosition="on-border"
      >
        <b-checkbox
          true-value="true"
          false-value="false"
          :disabled="isDisabled=='true'"
          :id="idName2"
          v-model="check"
          @click.native="doNotRequired(check)"
          class="requiredCheckBox"
        ></b-checkbox>
        必須解除
      </b-field>
    </div>
  </div>
  `,
  data: function() {
    var check = false;
    var target = this.fieldName;
    var result = this.$props.checks.filter(function(item) {
      return item == target;
    });
    if (result.length > 0) {
      check = true;
    }
    return {
      dataValue: this.value,
      idName: this.fieldName + "_check",
      idName2: this.fieldName + "_check2",
      check: this.requiredcheck
    };
  },
  methods: {
    addStyleBackColor: function() {
      if (this.isDisabled == "true") {
        return {
          "background-color": "#E1E1E1"
        };
      }
    },
    addStyleTextColor: function(isValidateRequired) {
      // 必須項目
      if (isValidateRequired.indexOf("required") != -1) {
        return {
          color: "red"
        };
      }
    },
    inputValue(result, fieldName) {
      this.dataValue = result;
      var flg = false;
      if (
        this.displayName.indexOf("本体SpO2") != -1 ||
        this.displayName.indexOf("本体EtCO2") != -1
      ) {
        flg = true;
      }
      this.$emit("child-event", result, this.subscript, this.index, flg);
    },
    doNotRequired(checker) {
      if (checker == false || checker == "false") {
        this.$parent.checks.push(this.fieldName);
        this.$parent.$parent.$parent.$parent.$parent.$parent.checkList.push(this.fieldName);
        this.$emit("child-event-requiredCheck",true,this.index);
      }
      else {
        var items = this.$parent.checks;
        var target = this.fieldName;
        var result = items.filter(function(item) {
          return item != target;
        });
        this.$parent.checks = result;

        var items = this.$parent.$parent.$parent.$parent.$parent.$parent.checkList;
        var target = this.fieldName;
        var result = items.filter(function(item) {
          return item != target;
        });
        this.$parent.$parent.$parent.$parent.$parent.$parent.checkList = result;
        this.$emit("child-event-requiredCheck",false,this.index);
      }
    },
    getSelectValue(displayValue, prescription) {
      if (!prescription) {
        return "";
      }

      var value = "";
      for (var i in displayValue) {
        if (displayValue[i].key === prescription) {
          value = displayValue[i].value;
        }
      }
      return value;
    },
    getPrescriptionValue(val) {
      if (val == "-" || val == "null") {
        return "";
      } else {
        return val;
      }
    },
    copy() {
      if (
        this.prescription != "-" &&
        this.prescription != "" &&
        this.prescription != null &&
        this.prescription != "null"
      ) {
        // エラーリセット
        this.errors.remove(this.fieldName);
        this.dataValue = this.prescription;
      }
    },
    letsValidate: async function() {
      const result = await this.$validator.validateAll();
      this.$parent.$parent.$parent.totalResult =
        this.$parent.$parent.$parent.totalResult && result;
      return result;
    }
  }
};

const RadioCompTemplate = {
  props: [
    "displayName",
    "displayValue",
    "subscript",
    "index",
    "value",
    "fieldName",
    "isValidateRequired",
    "isDisabled",
    "contentsType"
  ],
  template: `
    <div class="columns row" v-bind:style="addStyleBackColor()">
      <!--No.-->
      <div class="column is-1" style="text-align:left; margin-left:10px;">{{index+1}}</div>
      <!--点検内容-->
      <div class="column is-3" style="text-align:left;">
        <span v-if="displayName" v-bind:style="addStyleTextColor(isValidateRequired)">
          {{displayName}}
        </span>
      </div>
      <!--処方値-->
      <div class="column is-2" style="text-align:left; margin-left:10px;" />
      <!--変更チェック-->
      <div class="column is-checkBoxCol" style="text-align:left; margin-left:10px;" />
      <!--点検値-->
      <div class="column" v-if="isDisabled!='true'" style="text-align: left; margin-left:10px;">
        <b-field
          label
          labelPosition="on-border"
        >
          <b-radio
            v-for="tmpValue in displayValue"
            v-model="tmpValue.key"
            :value="tmpValue.value"
            :key="tmpValue.key"
            :name="fieldName"
            :native-value="dataValue"
            @click.native="inputRadioValue(tmpValue.key,fieldName)"
            data-vv-as="点検値"
            :disabled="isDisabled=='true'"
            v-validate="isValidateRequired"
            style="text-align:left; margin-Right:10px;"
          >{{tmpValue.value}}</b-radio>
        </b-field>
        <b-field>
          <span v-if="errors.has(fieldName)" style="color:red;">{{errors.first(fieldName)}}</span>
        </b-field>
      </div>
    </div>
  `,
  data: function() {
    return {
      dataValue: this.value
    };
  },
  created: function() {
    this.$validator.extend("requiredCheck", {
      getMessage: field => `点検値は必須項目です`,
      validate: (value, valueList) => {
        var ret = true;
        // 入力値チェック
        if (valueList[0] != null) {
          valueList[0] = valueList[0] + "".replace(" ", "").replace("　", "");
        }
        if (valueList[0] == null || valueList[0] == "") {
          ret = false;
        }
        return ret;
      }
    });
  },
  methods: {
    addStyleBackColor: function() {
      if (this.isDisabled == "true") {
        return {
          "background-color": "#E1E1E1"
        };
      }
    },
    addStyleTextColor: function(isValidateRequired) {
      // 必須項目
      if (isValidateRequired.indexOf("required") != -1) {
        return {
          color: "red"
        };
      }
    },
    inputRadioValue(result, fieldName) {
      // エラーリセット
      this.errors.remove(fieldName);
      this.dataValue = result;
      this.$emit("child-event", result, this.subscript, this.index, false);
    },
    letsValidate: async function() {
      const result = await this.$validator.validateAll();
      this.$parent.$parent.$parent.totalResult =
        this.$parent.$parent.$parent.totalResult && result;
      return result;
    }
  }
};

import * as inspectionUtil from "../utils/inspection"

export default {
  name: "AppInspectionExecuteSub",
  props: [
    "inspectionItem",
    "subscript",
    "productMaster",
    "targetContentsType",
    "checkList",
    //"limitCollection"
  ],
  methods: {
    checkValid: async function() {
      // 親画面から呼ばれる
      let result = true;
      this.totalResult = true;
      const childitems = this.$refs.itemvaluecompo;
      for (let i = 0; i < childitems.length; i++) {
        let tmpitem = childitems[i];
        result = result && tmpitem.letsValidate();
        let fname = tmpitem.fieldName;
        let nval = tmpitem.value;
        let index1 = parseInt(fname.split("_")[1]);
        let index2 = parseInt(fname.split("_")[2]) - 1; // index2は1始まりのため-1する
        this.inspectionItem.value[index2].value = tmpitem.dataValue;
      }
      result = result && this.$validator.validateAll();
      result.then(validatorResult => {
        if (validatorResult && this.totalResult) {
          return true;
        } else {
          scrollTo(0, 0);
          // エラーメッセージ表示
          this.showErrorMessage(
            "「変更値」に値が入っていないか、入力に誤りがあります。<br>「変更値」を再確認してください。"
          );
          return false;
        }
      });
    },
    getCheckList: function() {
      // 親画面から呼ばれる
      return this.checks;
    },
    getItems: function() {
      // 親画面から呼ばれる
      return this.inspectionItem;
    },
    getNextInspection: function(item, isChangeFlg) {
      // リースアップ ＋ 機械交換時
      if (item.inspectionOrder != 3) {
        var displayDate = this.getNextInspectionDate(
          this.inspectionDate,
          Number(item.CTERM),
          item.LTDAT,
          item.nextMaintenanceDate,
          false
        );
        if (displayDate) {
          displayDate = this.formatDate2(displayDate.date);
          return isChangeFlg ? displayDate.slice(0, 7) : displayDate;
        } else {
          return "";
        }
      } else if (item.machineReplaceProductCode != "") {
        var displayDate = this.formatDate2(
          this.getNextInspectionDate(
            this.inspectionDate,
            Number(item.CTERM),
            item.LTDAT,
            item.nextMaintenanceDate,
            true
          ).date
        );
        return isChangeFlg ? displayDate.slice(0, 7) : displayDate;
      }
    },
    setValue: function(result, subscript, index, flg) {
      if (this.inspectionItem.value[index].value != result) {
        this.$set(this.inspectionItem.value[index], "value", result);
        if (flg) {
          var displayName = this.inspectionItem.value[index].displayName;
          var contentsType =
            Number(this.inspectionItem.value[index].contentsType) - 1;
          if (displayName.indexOf("本体SpO2") != -1) {
            var targetItem1 = this.$refs.itemvaluecompo.filter(
              value => value.displayName.indexOf("SpO2上限") != -1
            );
            var targetItem2 = this.$refs.itemvaluecompo.filter(
              value => value.displayName.indexOf("SpO2下限") != -1
            );
          } else if (displayName.indexOf("本体EtCO2") != -1) {
            var targetItem1 = this.$refs.itemvaluecompo.filter(
              value => value.displayName.indexOf("EtCO2上限") != -1
            );
            var targetItem2 = this.$refs.itemvaluecompo.filter(
              value => value.displayName.indexOf("EtCO2下限") != -1
            );
          }
          if (result == "0") {
            this.$set(this.inspectionItem.value[index + 1], "value", "");
            this.$set(this.inspectionItem.value[index + 2], "value", "");
            this.$set(targetItem1[0], "dataValue", "");
            this.$set(targetItem2[0], "dataValue", "");
          }
          this.checkDisable(
            this.inspectionItem.subContentsValue,
            this.inspectionItem.value[index + 1].contentsType,
            this.inspectionItem.value[index + 1].displayName,
            this.index
          );
        }
      }
    },
    limitCheck: function(result, subscript, index, checkNumber, machineType) {
      if (this.inspectionItem.version > 0) {
        if (this.inspectionItem.value[index].value != result) {
          this.$set(this.inspectionItem.value[index], "value", result);
          var checkFlg = false;
          if (machineType == 8) {
            //プリズマ 上限下限入力値チェック
            var min, max;
            var minMax = this.limitCollection.filter(
              val => val.value == checkNumber
            );
            if (minMax && minMax.length == 2) {
              minMax.forEach(value => {
                switch (value.type) {
                  case "min":
                    min = this.inspectionItem.value.filter(
                      val => val.displayName == value.key
                    );
                    break;
                  case "max":
                    max = this.inspectionItem.value.filter(
                      val => val.displayName == value.key
                    );
                    break;
                }
              });
            }
            if (
              min.length > 0 &&
              min[0].value &&
              max.length > 0 &&
              max[0].value
            ) {
              if (Number(min[0].value) > Number(max[0].value)) {
                checkFlg = true;
              }
            }
            // エラーセット
            const childitems = this.$refs.itemvaluecompo;
            var cnt = 0;
            for (let i = 0; i < childitems.length; i++) {
              if (cnt == 2) {
                break;
              }
              let tmpitem = childitems[i];
              let fname = tmpitem.fieldName;
              if (fname.split("_")[1] == subscript) {
                if (
                  minMax[0].key == tmpitem.displayName ||
                  minMax[1].key == tmpitem.displayName
                ) {
                  tmpitem.checkFlg = checkFlg;
                  cnt += 1;
                }
              }
            }
          }
        }
      }
    },
    setRequiredCheck: function (requiredcheck, index){
      this.$set(this.inspectionItem.value[index], "requiredcheck", requiredcheck);
    },
    // limitCheck: function(result, subscript, index, checkNumber, machineType) {
    //   if (this.inspectionItem.version > 0) {
    //     if (this.inspectionItem.value[index].value != result) {
    //       this.$set(this.inspectionItem.value[index], "value", result);
    //       var checkFlg = false;
    //       var collection = {};
    //       if (machineType == 8) {
    //         collection = {
    //           1: ["１回換気量　下限(Prog2)", "１回換気量　上限(Prog2)"],
    //           2: ["Vti　下限(Prog2)", "Vti　上限(Prog2)"],
    //           3: ["呼吸回数　下限(Prog2)", "呼吸回数　上限(Prog2)"],
    //           4: ["MV　下限(Prog2)", "MV　上限(Prog2)"],
    //           5: ["SpO2　下限(Prog2)", "SpO2　上限(Prog2)"],
    //           6: ["脈拍数　下限(Prog2)", "脈拍数　上限(Prog2)"],
    //           7: ["１回換気量　下限(Prog3)", "１回換気量　上限(Prog3)"],
    //           8: ["Vti　下限(Prog3)", "Vti　上限(Prog3)"],
    //           9: ["呼吸回数　下限(Prog3)", "呼吸回数　上限(Prog3)"],
    //           10: ["MV　下限(Prog3)", "MV　上限(Prog3)"],
    //           11: ["SpO2　下限(Prog3)", "SpO2　上限(Prog3)"],
    //           12: ["脈拍数　下限(Prog3)", "脈拍数　上限(Prog3)"]
    //         };
    //       }
    //       var min = this.inspectionItem.value.filter(
    //         val => val.displayName == collection[checkNumber][0]
    //       );
    //       var max = this.inspectionItem.value.filter(
    //         val => val.displayName == collection[checkNumber][1]
    //       );
    //       if (
    //         min.length > 0 &&
    //         min[0].value &&
    //         max.length > 0 &&
    //         max[0].value
    //       ) {
    //         if (Number(min[0].value) > Number(max[0].value)) {
    //           checkFlg = true;
    //         }
    //       }
    //       // エラーセット
    //       const childitems = this.$refs.itemvaluecompo;
    //       var cnt = 0;
    //       for (let i = 0; i < childitems.length; i++) {
    //         if (cnt == 2) {
    //           break;
    //         }
    //         let tmpitem = childitems[i];
    //         let fname = tmpitem.fieldName;
    //         if (fname.split("_")[1] == subscript) {
    //           if (collection[checkNumber].indexOf(tmpitem.displayName) != -1) {
    //             tmpitem.checkFlg = checkFlg;
    //             cnt += 1;
    //           }
    //         }
    //       }
    //     }
    //   }
    // },
    getDisplayValue(displayValue, name) {
      var val = JSON.parse(JSON.stringify(displayValue));
      return val;
    },
    checkDisable: function(subContentsValue, contentsType, displayName,index) {
      if (
        !contentsType ||
        contentsType == 1 ||
        !subContentsValue ||
        (subContentsValue && subContentsValue.indexOf(contentsType + "") != -1)
      ) {
        if(this.inspectionItem.machineType == 11) {
          var cuffAssist2List = Object.keys(this.cuffAssist2Items);
          var cuffAssist2NotPercussorList = Object.keys(this.cuffAssist2NotPercussorItems);
          var targetName = displayName;
          var no = -1;
          var no = targetName.lastIndexOf("(");
          if (no != -1) {
            // 「(」以前でトリミング
            targetName = targetName.substring(0, no);
          }

          if (cuffAssist2List.indexOf(targetName) != -1) {
            // パーカッサー選択時のみ非活性項目の場合
            var self = this.inspectionItem.value.filter(value => value.displayName == displayName);

            // 対象項目から「動作モード」までのoffsetを取得
            var item = this.cuffAssist2Items[targetName];
            if (item) {
              var target = this.inspectionItem.value.filter(
                value => value.displayOrder == self[0].displayOrder - item
              );
              if (target[0].value == "3") {
                return true;
              }
            }
          }
          if (cuffAssist2NotPercussorList.indexOf(targetName) != -1) {
              // 自動、手動選択時のみ非活性項目の場合
              var self = this.inspectionItem.value.filter(value => value.displayName == displayName);

              // 対象項目から「動作モード」までのoffsetを取得
              var item = this.cuffAssist2NotPercussorItems[targetName];
              if (item) {
                var target = this.inspectionItem.value.filter(
                  value => value.displayOrder == self[0].displayOrder - item
                );
                if (target[0].value == "1" || target[0].value == "2") {
                  return true;
                }
              }
            }
          return false;
        }
        var self = this.inspectionItem.value.filter(value => value.displayName == displayName);
        switch (true) {
          case /SpO2下限/.test(displayName):
          case /EtCO2上限/.test(displayName):
            var target = this.inspectionItem.value.filter(
              value => value.displayOrder == self[0].displayOrder - 2
            );
            break;
          case /SpO2上限/.test(displayName):
          case /EtCO2下限/.test(displayName):
            var target = this.inspectionItem.value.filter(
              value => value.displayOrder == self[0].displayOrder - 1
            );
            break;
          default:
            return false;
            break;
        }
        if (target[0].value == "0") {
          return true;
        }
        return false;
      }
      return true;
    },
    checkRequired: function(
      productCode,
      type,
      sapFlg,
      requireFlg,
      prescription,
      subContentsValue,
      contentsType,
      diaplayOrder,
      fieldName,
      displayName
    ) {
      var ret = true;

      //必須解除チェックのチェックをしている場合は優先して、チェック
      if(this.checkList.indexOf(fieldName) != -1){
        return false
      }

      if (
        displayName.indexOf("SpO2下限") != -1 ||
        displayName.indexOf("EtCO2上限") != -1
      ) {
        var target = this.inspectionItem.value.filter(
          value => value.displayOrder == diaplayOrder - 2
        );
        if (target[0].value == "0") {
          return false;
        }
      }
      if (
        displayName.indexOf("SpO2上限") != -1 ||
        displayName.indexOf("EtCO2下限") != -1
      ) {
        var target = this.inspectionItem.value.filter(
          value => value.displayOrder == diaplayOrder - 1
        );
        if (target[0].value == "0") {
          return false;
        }
      }
      if (sapFlg) {
        // SAP項目の場合
        if (type == "char" && prescription != null) {
          prescription = prescription.replace(/\./g, "").replace(/0/g, "");
        }
        if (
          prescription == "" ||
          prescription == null ||
          prescription == "null" ||
          this.checkList.indexOf(fieldName) != -1
        ) {
          // 処方値が「0」「空白」でない場合、必須
          if (!requireFlg) {
            // 必須項目フラグがTRUEの場合、必須
            ret = false;
          }
        }
      } else {
        // SAP項目以外の場合
        if (!requireFlg) {
          // 必須項目フラグがTRUEの場合、必須
          ret = false;
        }
      }
      // 必須解除が押されている項目の必須項目を外す
      var result = this.checks.filter(function(item) {
        return item == fieldName;
      });
      if (result == fieldName) {
        ret = false;
      }
      return ret;
    },
    getSelectValue(displayValue, prescription) {
      if (!prescription) {
        return "";
      }

      var value = "";
      for (var i in displayValue) {
        if (displayValue[i].key === prescription) {
          value = displayValue[i].value;
        }
      }
      return value;
    },
    inputRadioValue(subscript, index, result, fieldName) {
      this.inspectionItem.value[index].value = result;
      // エラーリセット
      this.errors.remove(fieldName);
    },
    copy(val, subscript, index, fieldName) {
      if (!document.getElementById(val).control.checked) {
        if (
          this.inspectionItem.value[index].prescription != "-" &&
          this.inspectionItem.value[index].prescription != "" &&
          this.inspectionItem.value[index].prescription != null &&
          this.inspectionItem.value[index].prescription != "null"
        ) {
          // エラーリセット
          this.errors.remove(fieldName);
          this.inspectionItem.value[index].value =
            inspectionItem.value[index].prescription;
        }
      }
    },
    subValidateChecker() {
      // 子要素の点検入力データをdataに更新する（性能改善で子コンポーネント化したことによりバインディングが切れるため）
      const childitems = this.$refs.itemvaluecompo;
      for (let i = 0; i < childitems.length; i++) {
        let tmpitem = childitems[i];
        tmpitem.letsValidate();
      }
    },
    check() {
      // 子要素の点検入力データをdataに更新する（性能改善で子コンポーネント化したことによりバインディングが切れるため）
      const childitems = this.$refs.itemvaluecompo;
      for (let i = 0; i < childitems.length; i++) {
        let tmpitem = childitems[i];
        tmpitem.letsValidate();
      }
      this.$validator.validateAll();
    },
    expendablesOrder: function(event) {
      // 子要素の点検入力データをdataに更新する（性能改善で子コンポーネント化したことによりバインディングが切れるため）
      const childitems = this.$refs.itemvaluecompo;
      for (let i = 0; i < childitems.length; i++) {
        let tmpitem = childitems[i];
        let fname = tmpitem.fieldName;
        let nval = tmpitem.value;
        let index1 = parseInt(fname.split("_")[1]);
        let index2 = parseInt(fname.split("_")[2]) - 1; // index2は1始まりのため-1する
        this.data[index1].value[index2].value = tmpitem.dataValue;
      }

      // 点検中断
      this.regist().then(result => {
        if (this.compleateFlg) {
          this.doReturn();
        }
      });
    },
    getInputFieldName: function(subscript, index) {
      return "input_" + subscript + "_" + index;
    },
    getSelectFieldName: function(subscript, index) {
      return "sel_" + subscript + "_" + index;
    },
    getRadioFieldName: function(subscript, index) {
      return "radio_" + subscript + "_" + index;
    },
    getnextUpDateFieldName: function(subscript, index) {
      return "nextUpDate" + subscript + index;
    },
    getPrescriptionValue(value) {
      if (value == "-" || value == "null") {
        return "";
      } else {
        return value;
      }
    },

    header: function(inspectionItem, content){
      let header;
      if (content.contentsType == this.targetContentsType) {
        header = inspectionUtil.INSPECTION_HEADER[inspectionItem.machineType][content.contentsType][content.displayOrder];
      }

      return header;
    },
  },
  data() {
    var inspectionDate = new Date();
    var compleateFlg = false;
    var checks = this.$props.checkList;
    sessionStorage.getItem("officeMaster");
    // 点検指示内容
    var inspectionOrderList = [
      { key: 0, value: "設置" },
      { key: 1, value: "定期点検" },
      { key: 2, value: "メンテナンス" },
      { key: 4, value: "緊急対応" },
      { key: 3, value: "その他" },
      { key: 99, value: "" }
    ];
    var limitCollection = [
      //プリズマ Prog2
      { key: "１回換気量　下限(Prog2)", value: 1, type: "min" },
      { key: "１回換気量　上限(Prog2)", value: 1, type: "max" },
      { key: "Vti　下限(Prog2)", value: 2, type: "min" },
      { key: "Vti　上限(Prog2)", value: 2, type: "max" },
      { key: "呼吸回数　下限(Prog2)", value: 3, type: "min" },
      { key: "呼吸回数　上限(Prog2)", value: 3, type: "max" },
      { key: "MV　下限(Prog2)", value: 4, type: "min" },
      { key: "MV　上限(Prog2)", value: 4, type: "max" },
      { key: "SpO2　下限(Prog2)", value: 5, type: "min" },
      { key: "SpO2　上限(Prog2)", value: 5, type: "max" },
      { key: "脈拍数　下限(Prog2)", value: 6, type: "min" },
      { key: "脈拍数　上限(Prog2)", value: 6, type: "max" },
      //プリズマ Prog3
      { key: "１回換気量　下限(Prog3)", value: 7, type: "min" },
      { key: "１回換気量　上限(Prog3)", value: 7, type: "max" },
      { key: "Vti　下限(Prog3)", value: 8, type: "min" },
      { key: "Vti　上限(Prog3)", value: 8, type: "max" },
      { key: "呼吸回数　下限(Prog3)", value: 9, type: "min" },
      { key: "呼吸回数　上限(Prog3)", value: 9, type: "max" },
      { key: "MV　下限(Prog3)", value: 10, type: "min" },
      { key: "MV　上限(Prog3)", value: 10, type: "max" },
      { key: "SpO2　下限(Prog3)", value: 11, type: "min" },
      { key: "SpO2　上限(Prog3)", value: 11, type: "max" },
      { key: "脈拍数　下限(Prog3)", value: 12, type: "min" },
      { key: "脈拍数　上限(Prog3)", value: 12, type: "max" }
    ];
    //カフアシスト2: パーカッサーモードのみ非活性項目
    var cuffAssist2Items = {
      呼気圧: 3,
      吸気流量: 4,
      吸気時間: 5,
      呼気時間: 6,
      一時停止時間: 7,
      "Cough-Sync": 8,
      "Cough-Syncレベル": 9,
      オシレーション: 10,
      オシレーション周波数: 11,
      オシレーション振幅圧力: 12
    };
    //カフアシスト2: 自動、手動モードのみ非活性項目
    var cuffAssist2NotPercussorItems = {
      "パーカッサー振動数":13,
      "パーカッサー動作時間(分)": 14,
      "パーカッサー動作時間(秒)": 15,
      "I:E Ratio": 16
    }
    return {
      limitCollection,
      inspectionOrderList,
      totalResult: true,
      inspectionDate,
      compleateFlg,
      checks,
      cuffAssist2Items,
      cuffAssist2NotPercussorItems
    };
  },
  mounted: function() {
    //親画面でチェックされた副項目のみヴァリデーションチェック
    if (
      this.inspectionItem.subContentsValue.indexOf(
        this.targetContentsType + ""
      ) != -1
    ) {
      this.subValidateChecker();
    }
  },
  filters: {
    productFilter: function(value, productMaster) {
      if (!value) {
        return "";
      }
      var productElement = productMaster.find(v => v.productCode == value);
      if (productElement) {
        return productElement.productName;
      }
      return "";
    }
  },
  components: {
    "char-comp": CharCompTemplate,
    "sel-comp": SelCompTemplate,
    "radio-comp": RadioCompTemplate,
    "heading-comp": HeadingCompTemplate
  },
  computed: {},
  created: function() {}
};
</script>
<style lang="scss">
.header {
  border-bottom: double;
}
.row {
  border-bottom: 1px solid;
}
canvas.drawingBuffer {
  position: absolute;
  left: 0;
}
.column.is-checkBoxCol {
  width: 30px;
  -webkit-box-flex: 0;
  -ms-flex: none;
  flex: none;
}
.requiredCheckBox {
  width: 20px;
}
.requiredText {
  position: absolute;
  text-indent: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/AppInspectionExecuteSub.vue